import type { JourneyCloseAction } from '../types/actions'

import { actionFactory } from './factory'
import { journeyReset } from './journeyReset'
import { setInitialStep } from './setInitialStep'

/**
 * Closes the current Journey while clearing all specific state.
 * Used by the "close" buttons throughtout the App.
 */
export const journeyClose = actionFactory<JourneyCloseAction>((state) => {
  // resets the journey-bounded state
  journeyReset(undefined, state)

  // WARNING: should be kept in sync with the logic in `AppManager`
  // re-selects the initial first step
  setInitialStep(
    {
      initialStepIndexOverride:
        state.appParams?.dataInjectionOptions?.initialStepIndex
    },
    state
  )
}, 'journeyClose')
